import { simpleRichTextRender } from '../utils/rich-text-utils';
import Link from 'next/link';
import { MouseEvent, useMemo } from 'react';
import { Block, Inline, BLOCKS, TopLevelBlock } from '@contentful/rich-text-types';

export interface LinkRenderProps {
    data: Block['data'] | Inline['data'];
    content: Block['content'] | Inline['content'];
    type: 'AssetLink' | 'PlainLink';
    onClick?: (event: MouseEvent<HTMLElement>) => void;
}

export const LinkRender = (props: LinkRenderProps) => {
    const target = props.data['target'] as { fields: { file: { url: string } } } | undefined;
    const uri = props.data['uri'] as string | undefined;
    const href = props.type === 'AssetLink' ? `https://${target?.fields?.file?.url}` : uri;
    const linkText = simpleRichTextRender({
        content: props.content as TopLevelBlock[],
        data: {},
        nodeType: BLOCKS.DOCUMENT,
    });

    const isExternalHost = useMemo(() => {
        if (typeof window === 'undefined' || !uri) return false;

        const browserHostName = window.location.hostname;
        const splitName = uri.split('/');

        return browserHostName !== splitName[2];
    }, [uri]);

    const linkAttributes: { onClick?: (event: MouseEvent<HTMLElement>) => void } = {};

    if (props.onClick) {
        linkAttributes.onClick = props.onClick;
    }

    if (isExternalHost) {
        return (
            <Link href={href || ''} {...linkAttributes} rel="noopener noreferrer" target="_blank">
                {linkText}
            </Link>
        );
    }

    return (
        <Link href={href || ''} {...linkAttributes} rel="noopener noreferrer">
            {linkText}
        </Link>
    );
};

export default LinkRender;
